import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Conversation } from '../../models/conversation';
import { ConversationService } from '../../services/conversation.service';
import { ToastService } from 'src/app/utils/services/toast.service';
import { ModalController } from '@ionic/angular';
import { WarningModalComponent } from 'src/app/share/components/modals/warning-modal/warning-modal.component';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { User } from 'src/app/core/auth/models';

@Component({
  standalone: false,
  selector: 'app-conversations-history',
  templateUrl: './conversations-history.component.html',
  styleUrls: ['./conversations-history.component.scss'],
})
export class ConversationsHistoryComponent implements OnInit {
  allSelected: boolean = false;

  @Input() conversations: Conversation[] = [];
  @Output() openConversation = new EventEmitter<Conversation>();
  @Output() refreshConversations = new EventEmitter<Conversation>();
  @Output() deleteConversationEvent = new EventEmitter<void>();
  @Output() deleteConversations = new EventEmitter<Conversation[]>();
  editingId: number = -1;
  editingTitle: string = '';
  user: User | undefined = undefined;
  selectedConversations: Conversation[] = [];


  constructor(private chatService: ConversationService, 
    private authService: AuthService,
    private toast: ToastService, 
    private modalController: ModalController) { }

  ngOnInit() {
    this.authService.$user.subscribe(user => {
      this.user = user;
    });
    // Inicializar propiedad selected en cada conversación
    this.conversations.forEach((c: any) => c.selected = false);
  }

  getSelectedConversations(): Conversation[] {
    return this.conversations.filter((c: any) => c.selected);
  }

  onSelectConversation(conversation: any): void {
    if (conversation.selected) {
      if (!this.selectedConversations.includes(conversation)) {
        this.selectedConversations.push(conversation);
      }
    } else {
      this.selectedConversations = this.selectedConversations.filter((c: any) => c !== conversation);
    }
  }

    toggleSelectAll(): void {
    this.allSelected = this.allSelected ? true : false;
    
    this.conversations.forEach((c: any) => {
      c.selected = this.allSelected;
      this.onSelectConversation(c);
    });
  }

  async deleteSelectedConversations(): Promise<void> {
    
    if (this.selectedConversations.length === 0) return;
    const modalRef = await this.modalController.create({
      component: WarningModalComponent,
      cssClass: "active-connector-dialog",
      componentProps: {
        title: "Eliminar conversaciones",
        text: `¿Desea eliminar ${this.selectedConversations.length} conversaciones seleccionadas?`,
        icon: "warning-outline",
        iconColor: "danger"
      }
    });
    await modalRef.present();
    await modalRef.onDidDismiss()
      .then(resp => {
        if (resp.role == 'confirm') {
          this.selectedConversations.forEach((conversation: any) => {
            this.deleteConversation(conversation, true, true);
          });
          this.refreshConversations.emit(this.conversations[0]);
          this.selectedConversations = [];
        }
      });
  }

  async openSettingsModal() {
      //  const modalRef = await this.modalController.create({
      //     component: ChatSettingsComponent,
      //     componentProps: {
      //       userId: this.user?.id,
      //     },
      //     cssClass: "user-form-dialog",
      //   });
    
      //   modalRef.present();
    
  }


  enableEditing(conversation: Conversation, index: number, event: MouseEvent) {

    this.editingId = index;
    this.editingTitle = conversation.title!;

  }

  saveTitle(conversation: Conversation, external?: boolean) {

    if (this.editingTitle === conversation.title) {
      this.editingId = -1; // Finaliza la edición
      return; // No hay cambios en el título, no se necesita guardar

    }

    if (this.editingId! > -1 || external) {
      conversation.title = this.editingTitle; // Actualiza el título de la conversación
      this.editingId = -1; // Finaliza la edición

      this.chatService.updateConversation(conversation).subscribe(
        {
          next: (response) => {
           // this.toast.success('Conversación actualizada satisfactoriamente');
            this.editingId = -1; // Finaliza la edición
            this.refreshConversations.emit(conversation); // Emitir el evento de eliminación
            this.editingTitle = ''; // Limpiar el título editado
          },
          error: (error) => {
            this.toast.error('Error al actualizar la conversación');
            this.editingTitle = ''; // Limpiar el título editado
            console.error(error);
          },
        }
      );
    }
  }

  cancelEditing() {
    this.editingId = -1; // Cancela la edición sin guardar
  }

  selectConversation(conversation: Conversation) {
    this.openConversation.emit(conversation);
  }

  async showDeleteAlert(conversation: Conversation) {
    const modalRef = await this.modalController.create({
      component: WarningModalComponent,
      cssClass: "active-connector-dialog",
      componentProps: {
        title: "Eliminar Conversación",
        text: `¿Desea Eliminar la conversación ${conversation.title}?`,
        icon: "warning-outline",
        iconColor: "danger"
      }
    });

    modalRef.present();

    await modalRef.onDidDismiss()
      .then(resp => {
        if (resp.role == 'confirm') {
          this.deleteConversation(conversation);
        }
      });
  }



  deleteConversation(conversation: Conversation, silent?: boolean, deleteAll?: boolean ) {
    this.chatService.deleteConversation(conversation.id!).subscribe(
      {
        next: (response) => {
          if (!silent) {
            this.toast.success('Conversación eliminada satisfactoriamente');
          }
          
          if (!deleteAll) 
          this.refreshConversations.emit(conversation);
        },
        error: (error) => {
          if (!silent) {
            this.toast.error('Error al eliminar la conversación');
          }
          console.error(error);
        },
      }
    );
  }

}
